
/* Shopify theme shim: maps site-relative asset paths to flattened CDN assets */
function EOURL(p) {
  if (!p || p.indexOf("assets/") !== 0) return p;
  var parts = p.split("/"); parts.shift();
  var kind = parts.shift();
  var prefix = kind === "img" ? "img--" : kind === "video" ? "vid--" : "";
  var flat = (prefix + parts.join("--")).normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  return (window.EO_CDN || "") + flat;
}
/* ============================================================
   Extensiones Orgánicas — Product catalog
   Data source: Shopify store cjn3as-41.myshopify.com (Admin API).
   Every color of every line maps to a real Shopify product +
   variant ID, so add-to-cart / checkout use cart permalinks:
   https://{shop}/cart/{variantId}:{qty}
   Customer-facing strings are Spanish; keys/comments English.
   Variant IDs reused verbatim from the original catalog.
   ============================================================ */

const SHOP_URL = "https://cjn3as-41.myshopify.com";
const FREE_SHIPPING_THRESHOLD = 50; // EUR

/* Master color chart. Hex = approximate chip color (fallback/accents). */
const COLOR_INFO = {
  "1":        { name: "Negro Azabache",    family: "negro",   hex: "#17130f", desc: "Negro intenso y profundo." },
  "1B":       { name: "Negro Natural",     family: "negro",   hex: "#241d18", desc: "Negro suave con matiz cálido." },
  "2":        { name: "Chocolate",         family: "castaño", hex: "#39261d", desc: "Marrón oscuro, rico y brillante." },
  "4":        { name: "Castaño Oscuro",    family: "castaño", hex: "#4a3122", desc: "Castaño profundo con calidez." },
  "6":        { name: "Castaño",           family: "castaño", hex: "#5d4530", desc: "Castaño medio, natural y versátil." },
  "8":        { name: "Castaño Claro",     family: "castaño", hex: "#7c5c3b", desc: "Castaño luminoso con reflejos dorados." },
  "22":       { name: "Rubio Claro",       family: "rubio",   hex: "#d9b67e", desc: "Rubio dorado, cálido y luminoso." },
  "26MIX":    { name: "Mezcla Rubia",      family: "rubio",   hex: "#c9a468", desc: "Mezcla de rubio oscuro y claro." },
  "P4.613":   { name: "Chocolate y Rubio", family: "mechado", hex: "#77572f", desc: "Mechado chocolate con rubio claro." },
  "P8.24":    { name: "Castaño y Rubio",   family: "mechado", hex: "#a8895b", desc: "Mechado castaño con rubio ceniza." },
  "P18.613":  { name: "Rubio Mechado",     family: "mechado", hex: "#d3b078", desc: "Mechado rubio claro con rubio oscuro." },
  "SP18.613": { name: "Rubio Dorado Mix",  family: "mechado", hex: "#c8a76a", desc: "Mechado rubio oscuro y rubio dorado." },
  "MT18.613": { name: "Balayage Rubio",    family: "mechado", hex: "#c2a06a", desc: "Balayage de rubio oscuro a claro." },
  "F4.30.613":{ name: "Tricolor Caoba",    family: "mechado", hex: "#8a5f3a", desc: "Chocolate, rubio caoba y rubio claro." }
};

const FAMILIES = {
  negro:   "Negros",
  "castaño": "Castaños",
  rubio:   "Rubios",
  mechado: "Mechados y balayage"
};

/* Product lines. Every color: [code, imageFile, variantId, shopifyHandle] */
const CATALOG = [
  {
    id: "extensiones-clip",
    category: "clip",
    name: "Extensiones de Clip",
    subtitle: "Set de 6 piezas · 50 cm · 160 g",
    price: 49.00,
    badge: "Bestseller",
    tagline: "Volumen y largo instantáneos, listas en 5 minutos.",
    description: "Set completo de extensiones de clip de fibra orgánica premium: 6 piezas que cubren toda la cabeza para un resultado denso, sedoso y absolutamente natural. Se colocan en minutos, sin daño y sin compromiso.",
    specs: { largo: "50 cm", peso: "160 g", piezas: "6 piezas + clips cosidos" },
    imgDir: "assets/img/clip",
    detailDir: "assets/img/clip-detalle",
    extras: [
      ["assets/img/editorial/clipin-all-colors.webp", "Extensiones de clip en todos los tonos de la carta"],
      ["assets/img/editorial/hero-clipin.webp", "Extensiones de clip sobre seda color marfil"]
    ],
    cardImg: "assets/img/editorial/clipin-still.webp",
    colors: [
      ["1B",       "1b.webp",       "52687647867156", "extensiones-de-clip-6-piezas-50cm-160g-1b-negro-natural"],
      ["2",        "2.webp",        "52687647932692", "extensiones-de-clip-6-piezas-50cm-160g-2-chocolate"],
      ["4",        "4.webp",        "52687647965460", "extensiones-de-clip-6-piezas-50cm-160g-4-castano-oscuro"],
      ["6",        "6.webp",        "52687648030996", "extensiones-de-clip-6-piezas-50cm-160g-6-castano"],
      ["8",        "8.webp",        "52687648063764", "extensiones-de-clip-6-piezas-50cm-160g-8-castano-dorado"],
      ["22",       "22.webp",       "52687648096532", "extensiones-de-clip-6-piezas-50cm-160g-22-rubio"],
      ["26MIX",    "26.webp",       "52687648129300", "extensiones-de-clip-6-piezas-50cm-160g-26mix-mezcla-rubio-oscuro-y-claro"],
      ["P4.613",   "P4.613.webp",   "52687648194836", "extensiones-de-clip-6-piezas-50cm-160g-p4-613-mechado-chocolate-rubio"],
      ["P8.24",    "P8.24.webp",    "52687648227604", "extensiones-de-clip-6-piezas-50cm-160g-p8-24-mechado-rubio-y-castano"],
      ["P18.613",  "P18.613.webp",  "52687648260372", "extensiones-de-clip-6-piezas-50cm-160g-p18-613-mechado-rubio-claro-con-rubio-oscuro"],
      ["SP18.613", "SP18.613.webp", "52687648325908", "extensiones-de-clip-6-piezas-50cm-160g-sp18-613-rubio-oscuro-con-rubio-dorado"],
      ["MT18.613", "MT18.613.webp", "52687648358676", "extensiones-de-clip-6-piezas-50cm-160g-mt18-613-balayage-rubio-oscuro-rubio-claro"]
    ]
  },
  {
    id: "coleta-bloom",
    category: "coletas",
    name: "Coleta Lisa · Bloom",
    subtitle: "Lisa · 60 cm · 135 g",
    price: 39.00,
    badge: "Favorita",
    tagline: "La coleta lisa de largo perfecto para el día a día.",
    description: "Coleta lisa Bloom de 60 cm: melena sedosa, movimiento natural y colocación en segundos. Se envuelve y fija en tu propia coleta para un acabado pulido de salón.",
    specs: { largo: "60 cm", peso: "135 g", sistema: "Wrap con velcro y peineta" },
    imgDir: "assets/img/carta",
    wrapDir: "assets/img/coletas",
    extras: [
      ["assets/img/editorial/coleta-lisa-modelo.webp", "Modelo con coleta lisa Bloom"],
      ["assets/img/editorial/tutorial-wrap.webp", "Cómo colocar la coleta wrap paso a paso", "contain"],
      ["assets/img/editorial/antes-despues-2.webp", "Una transformación perfecta: antes y después", "contain"],
      ["assets/img/editorial/wrap-vs-pinza.webp", "Coleta wrap frente a coleta con pinza", "contain"],
      ["assets/img/editorial/wrap-velcro.webp", "Extensión de cola: sistema wrap con velcro por dentro y por fuera", "contain"]
    ],
    cardImg: "assets/img/editorial/coleta-lisa-modelo.webp",
    colors: [
      ["1",        "OH_1.webp",         "52687648391444", "coleta-lisa-bloom-60cm-135g-1-negro"],
      ["2",        "OH_2.webp",         "52687648456980", "coleta-lisa-bloom-60cm-135g-2-chocolate"],
      ["4",        "OH_4.webp",         "52687648489748", "coleta-lisa-bloom-60cm-135g-4-castano-oscuro"],
      ["6",        "OH_6.webp",         "52687648522516", "coleta-lisa-bloom-60cm-135g-6-castano"],
      ["8",        "OH_8.webp",         "52687648555284", "coleta-lisa-bloom-60cm-135g-8-castano-claro"],
      ["22",       "OH_22.webp",        "52687648620820", "coleta-lisa-bloom-60cm-135g-22-rubio-claro"],
      ["26MIX",    "OH_26.webp",        "52687648653588", "coleta-lisa-bloom-60cm-135g-26mix-mezcla-rubio-oscuro-y-claro"],
      ["P4.613",   "OH_P4.613.webp",    "52687651078420", "coleta-lisa-bloom-60cm-135g-p4-613-mechado-chocolate-rubio-claro"],
      ["P8.24",    "OH_P8.24.webp",     "52687648686356", "coleta-lisa-bloom-60cm-135g-p8-24-mechado-rubio-y-castano"],
      ["P18.613",  "OH_P18.613.webp",   "52687648751892", "coleta-lisa-bloom-60cm-135g-p18-613-mechado-rubio-claro-con-rubio-oscuro"],
      ["SP18.613", "OH_SP18.613.webp",  "52687648817428", "coleta-lisa-bloom-60cm-135g-sp18-613-mechado-rubio-oscuro-rubio-dorado"],
      ["MT18.613", "OH_MT18.613.webp",  "52687648850196", "coleta-lisa-bloom-60cm-135g-mt18-613-balayage-rubio-oscuro-rubio-claro"],
      ["F4.30.613","OH_F4.27.30.613.webp","52687648915732","coleta-lisa-bloom-60cm-135g-f4-30-613-mechado-chocolate-rubio-caoba-rubio-claro"]
    ]
  },
  {
    id: "coleta-bella",
    category: "coletas",
    name: "Coleta Lisa · Bella",
    subtitle: "Lisa XL · 75 cm · 170 g",
    price: 49.00,
    badge: "Extra largo",
    tagline: "Melena XL de infarto: 75 cm de pura elegancia.",
    description: "Coleta lisa Bella de 75 cm y 170 g: el largo más espectacular de la colección. Densidad de lujo, caída perfecta y brillo sedoso para looks de evento e invitada.",
    specs: { largo: "75 cm", peso: "170 g", sistema: "Wrap con velcro y peineta" },
    imgDir: "assets/img/carta",
    wrapDir: "assets/img/coletas",
    extras: [
      ["assets/img/editorial/coleta-negro-modelo.webp", "Modelo con coleta lisa XL en negro"],
      ["assets/img/editorial/tutorial-wrap.webp", "Cómo colocar la coleta wrap paso a paso", "contain"],
      ["assets/img/editorial/antes-despues-2.webp", "Una transformación perfecta: antes y después", "contain"],
      ["assets/img/editorial/wrap-vs-pinza.webp", "Coleta wrap frente a coleta con pinza", "contain"],
      ["assets/img/editorial/wrap-velcro.webp", "Extensión de cola: sistema wrap con velcro por dentro y por fuera", "contain"]
    ],
    cardImg: "assets/img/editorial/coleta-negro-modelo.webp",
    colors: [
      ["1",        "OH_1.webp",         "52687650586900", "coleta-lisa-bella-75cm-170g-1-negro"],
      ["2",        "OH_2.webp",         "52687650554132", "coleta-lisa-bella-75cm-170g-2-chocolate"],
      ["4",        "OH_4.webp",         "52687650521364", "coleta-lisa-bella-75cm-170g-4-castano-oscuro"],
      ["6",        "OH_6.webp",         "52687650488596", "coleta-lisa-bella-75cm-170g-6-castano"],
      ["8",        "OH_8.webp",         "52687650423060", "coleta-lisa-bella-75cm-170g-8-castano-claro"],
      ["22",       "OH_22.webp",        "52687650390292", "coleta-lisa-bella-75cm-170g-22-rubio-claro"],
      ["26MIX",    "OH_26.webp",        "52687650357524", "coleta-lisa-bella-75cm-170g-26mix-mezcla-rubio-oscuro-rubio-claro"],
      ["P4.613",   "OH_P4.613.webp",    "52687650619668", "coleta-lisa-bella-75cm-170g-p4-613-mechado-chocolate-rubio-claro"],
      ["P8.24",    "OH_P8.24.webp",     "52687650324756", "coleta-lisa-bella-75cm-170g-p8-24-mechado-rubio-y-castano"],
      ["P18.613",  "OH_P18.613.webp",   "52687650291988", "coleta-lisa-bella-75cm-170g-p18-613-mechado-rubio-claro-con-rubio-oscuro"],
      ["SP18.613", "OH_SP18.613.webp",  "52687650259220", "coleta-lisa-bella-75cm-170g-sp18-613-mechado-rubio-oscuro-rubio-dorado"],
      ["MT18.613", "OH_MT18.613.webp",  "52687650226452", "coleta-lisa-bella-75cm-170g-mt18-613-balayage-rubio-oscuro-rubio-claro"],
      ["F4.30.613","OH_F4.27.30.613.webp","52687650193684","coleta-lisa-bella-75cm-170g-f4-30-613-mechado-chocolate-rubio-caoba-rubio-claro"]
    ]
  },
  {
    id: "coleta-bianca",
    category: "coletas",
    name: "Coleta Ondulada · Bianca",
    subtitle: "Ondulada · 50 cm · 120 g",
    price: 39.00,
    badge: "Ondas",
    tagline: "Ondas suaves con movimiento de anuncio.",
    description: "Coleta ondulada Bianca de 50 cm: ondas fluidas y ligeras que se mueven como cabello propio. El punto romántico y effortless para cualquier ocasión.",
    specs: { largo: "50 cm", peso: "120 g", sistema: "Wrap con velcro y peineta" },
    imgDir: "assets/img/carta",
    extras: [
      ["assets/img/editorial/coleta-bianca-modelo.webp", "Modelo con coleta ondulada Bianca"],
      ["assets/img/editorial/tutorial-wrap.webp", "Cómo colocar la coleta wrap paso a paso", "contain"],
      ["assets/img/editorial/antes-despues-2.webp", "Una transformación perfecta: antes y después", "contain"],
      ["assets/img/editorial/wrap-vs-pinza.webp", "Coleta wrap frente a coleta con pinza", "contain"],
      ["assets/img/editorial/wrap-velcro.webp", "Extensión de cola: sistema wrap con velcro por dentro y por fuera", "contain"]
    ],
    cardImg: "assets/img/editorial/coleta-bianca-modelo.webp",
    colors: [
      ["1",        "OH_1.webp",         "52687650652436", "coleta-ondulada-bianca-50cm-120g-1-negro"],
      ["2",        "OH_2.webp",         "52687650685204", "coleta-ondulada-bianca-50cm-120g-2-chocolate"],
      ["4",        "OH_4.webp",         "52687650750740", "coleta-ondulada-bianca-50cm-120g-4-castano-oscuro"],
      ["6",        "OH_6.webp",         "52687650783508", "coleta-ondulada-bianca-50cm-120g-6-castano"],
      ["8",        "OH_8.webp",         "52687651111188", "coleta-ondulada-bianca-50cm-115g-8-castano-claro"],
      ["22",       "OH_22.webp",        "52687650816276", "coleta-ondulada-bianca-50cm-120g-22-rubio-claro"],
      ["26MIX",    "OH_26.webp",        "52687650849044", "coleta-ondulada-bianca-50cm-120g-26mix-mezcla-rubio-oscuro-y-claro"],
      ["P4.613",   "OH_P4.613.webp",    "52687651045652", "coleta-ondulada-bianca-50cm-120g-p4-613-mechado-chocolate-rubio-claro"],
      ["P8.24",    "OH_P8.24.webp",     "52687650881812", "coleta-ondulada-bianca-50cm-120g-p8-24-mechado-rubio-y-castano"],
      ["P18.613",  "OH_P18.613.webp",   "52687650914580", "coleta-ondulada-bianca-50cm-120g-p18-613-mechado-rubio-claro-con-rubio-oscuro"],
      ["SP18.613", "OH_SP18.613.webp",  "52687650947348", "coleta-ondulada-bianca-50cm-120g-sp18-613-mechado-rubio-oscuro-rubio-dorado"],
      ["MT18.613", "OH_MT18.613.webp",  "52687650980116", "coleta-ondulada-bianca-50cm-120g-mt18-613-balayage-rubio-oscuro-rubio-claro"],
      ["F4.30.613","OH_F4.27.30.613.webp","52687651012884","coleta-ondulada-bianca-50cm-120g-f4-30-613-mechado-chocolate-rubio-caoba-rubio-claro"]
    ]
  },
  {
    id: "coletero-lila",
    category: "coleteros",
    name: "Coletero Lila",
    subtitle: "Coletero de pelo · fibra orgánica",
    price: 13.33,
    badge: "Nuevo",
    tagline: "El moño perfecto en un solo gesto.",
    description: "Coletero Lila de fibra orgánica: envuélvelo alrededor de tu coleta y consigue un moño con volumen y textura en segundos. Ligero, cómodo y reutilizable.",
    specs: { estilo: "Moño pulido con textura", sistema: "Banda elástica, se enrolla en segundos" },
    /* All Lila color imagery (gallery hero + swatch grid) comes exclusively
       from the Coletero_Lila_swatch photos; shown uncropped (imgFit contain). */
    imgDir: "assets/img/lila-swatch-hd",
    imgFit: "contain",
    /* Category/bestseller card: model + product composite */
    cardImg: "assets/img/editorial/moño-lila.webp",
    extras: [
      ["assets/img/editorial/lila-modelo.webp", "Modelo con coletero Lila"],
      ["assets/img/editorial/coletero-como-ponerlos.webp", "Cómo ponerlo: paso a paso", "contain"],
      ["assets/img/editorial/coletero-detalle.webp", "Descripción detallada del coletero", "contain"],
      ["assets/img/editorial/coletero-material.webp", "Tu elección: material, peso y cuidados", "contain"],
      ["assets/img/editorial/coletero-ponerlos-facil.webp", "Fácil e instantáneo: ahorra tiempo", "contain"]
    ],
    colors: [
      ["1",        "Lila_1.webp",         "52687648948500", "coleta-lila-1-negro"],
      ["2",        "Lila_2.webp",         "52687648981268", "coletero-lila-2-chocolate"],
      ["4",        "Lila_4.webp",         "52687649014036", "coletero-lila-4-castano-oscuro"],
      ["6",        "Lila_6.webp",         "52687649079572", "coletero-lila-6-castano"],
      ["8",        "Lila_8.webp",         "52687649112340", "coletero-lila-8-castano-claro"],
      ["22",       "Lila_22.webp",        "52687649145108", "coletero-lila-22-rubio-dorado"],
      ["26MIX",    "Lila_26.webp",        "52687649210644", "coletero-lila-26mix-mechado-rubio-dorado-y-rubio-ceniza"],
      ["P4.613",   "Lila_P4.613.webp",    "52687649308948", "coletero-lila-p4-613-mechado-chocolate-y-rubio"],
      ["P8.24",    "Lila_P8.24.webp",     "52687649374484", "coletero-lila-p8-24-mechado-castano-y-rubio-ceniza"],
      ["P18.613",  "Lila_P18.613.webp",   "52687649407252", "coletero-lila-p18-613-mechado-rubio-dorado-y-rubio-claro"],
      ["SP18.613", "Lila_SP18.613.webp",  "52687649472788", "coletero-lila-sp18-613-mechado-rubio-claro-y-rubio-ceniza"],
      ["MT18.613", "Lila_MT18.613.webp",  "52687649276180", "coletero-lila-mt18613-mechado-rubio-oscuro-y-rubio-dorado"],
      ["F4.30.613","Lila_F4.30.613.webp", "52687649243412", "coletero-lila-f4-30-613-mechado-chocolate-rubio-dorado-rubio-medio-coaba"]
    ]
  },
  {
    id: "coletero-lola",
    category: "coleteros",
    name: "Coletero Lola",
    subtitle: "Coletero de pelo · fibra orgánica",
    price: 13.33,
    badge: "Nuevo",
    tagline: "Volumen instantáneo para tu coleta o moño.",
    description: "Coletero Lola de fibra orgánica: textura suelta y natural para elevar cualquier recogido. Combínalo con tu coleta para un extra de volumen sin esfuerzo.",
    specs: { estilo: "Moño despeinado, textura suelta", sistema: "Banda elástica, se enrolla en segundos" },
    /* All Lola color imagery (gallery hero + swatch grid) comes exclusively
       from the swatch-coletero-lola photos; shown uncropped (imgFit contain). */
    imgDir: "assets/img/lola-swatch-hd",
    imgFit: "contain",
    /* Category/bestseller card: model + product composite */
    cardImg: "assets/img/editorial/moño-lola.webp",
    extras: [
      ["assets/img/editorial/lola-elegante.webp", "Peinado elegante con coletero Lola"],
      ["assets/img/editorial/coletero-como-ponerlos.webp", "Cómo ponerlo: paso a paso", "contain"],
      ["assets/img/editorial/coletero-detalle.webp", "Descripción detallada del coletero", "contain"],
      ["assets/img/editorial/coletero-material.webp", "Tu elección: material, peso y cuidados", "contain"],
      ["assets/img/editorial/coletero-ponerlos-facil.webp", "Fácil e instantáneo: ahorra tiempo", "contain"]
    ],
    colors: [
      ["1",        "Lola_1.webp",         "52687649505556", "coletero-lola-1-negro"],
      ["2",        "Lola_2.webp",         "52687649571092", "coletero-lola-2-chocolate"],
      ["4",        "Lola_4.webp",         "52687649603860", "coletero-lola-4-castano-oscuro"],
      ["6",        "Lola_6.webp",         "52687649669396", "coletero-lola-6-castano"],
      ["8",        "Lola_8.webp",         "52687649702164", "coletero-lola-8-castano-claro"],
      ["22",       "Lola_22.webp",        "52687649800468", "coletero-lola-22-rubio-dorado"],
      ["26MIX",    "Lola_26.webp",        "52687649931540", "coletero-lola-26-mechado-rubio-dorado-y-rubio-ceniza"],
      ["P4.613",   "Lola_P4.613.webp",    "52687650128148", "coletero-lola-p4-613-mechado-castano-oscuro-y-rubio-claro"],
      ["P8.24",    "Lola_P8.24.webp",     "52687650095380", "coletero-lola-p8-24-mechado-castano-y-rubio-ceniza"],
      ["P18.613",  "Lola_P18.613.webp",   "52687649964308", "coletero-lola-p18-613-mechado-rubio-dorado-y-rubio-ceniza"],
      ["SP18.613", "Lola_SP18.613.webp",  "52687649997076", "coletero-lola-sp18-613-mechado-rubio-oscuro-y-rubio-ceniza"],
      ["MT18.613", "Lola_MT18.613.webp",  "52687650029844", "coletero-lola-mt18-613-mechado-rubio-claro-y-rubio-ceniza"],
      ["F4.30.613","Lola_F4.30.613.webp", "52687650160916", "coletero-lola-f4-30-613-mechado-chocolate-rubio-claro-rubio-medio-caoba"]
    ]
  }
];

const CATEGORIES = {
  clip:      { name: "Extensiones de Clip", slug: "clip",      blurb: "Sets completos de 6 piezas para volumen y largo total.",
               hero: "assets/img/editorial/clipin-still.webp" },
  coletas:   { name: "Coletas",             slug: "coletas",   blurb: "Tres modelos: lisa, lisa XL y ondulada. Un gesto, melena nueva.",
               hero: "assets/img/editorial/coletas-still.webp" },
  coleteros: { name: "Coleteros de Pelo",   slug: "coleteros", blurb: "Moños y recogidos con volumen en segundos.",
               hero: "assets/img/editorial/coleteros-still.webp" }
};

/* ---------- Helpers ---------- */
function getLine(id) { return CATALOG.find(function (l) { return l.id === id; }); }

function getColor(line, code) {
  var c = line.colors.find(function (x) { return x[0] === code; }) || line.colors[0];
  return { code: c[0], file: c[1], variantId: c[2], handle: c[3], info: COLOR_INFO[c[0]] };
}

function colorImg(line, colorArr) { return EOURL(line.imgDir + "/" + colorArr[1]); }

/* Gallery for a given line+color: main color shot, per-color detail/wrap
   shot when available, then the line's editorial extras. */
function galleryFor(line, code) {
  var c = getColor(line, code);
  /* fit: "contain" renders the image letterboxed — never cropped at the sides */
  var g = [{ src: EOURL(line.imgDir + "/" + c.file), alt: line.name + " en tono " + c.info.name, fit: line.imgFit }];
  var base = c.file.replace(/\.webp$/, "");
  if (line.productDir) {
    g.push({ src: EOURL(line.productDir + "/" + base + ".webp"), alt: line.name + " — producto en tono " + c.info.name, fit: line.imgFit });
  }
  if (line.detailDir) {
    g.push({ src: EOURL(line.detailDir + "/" + base + ".webp"), alt: "Detalle de " + line.name + " en tono " + c.info.name, fit: line.imgFit });
  }
  if (line.wrapDir) {
    g.push({ src: EOURL(line.wrapDir + "/wrap_" + c.code + ".webp"), alt: line.name + " colocada, tono " + c.info.name });
  }
  (line.extras || []).forEach(function (e) { g.push({ src: EOURL(e[0]), alt: e[1], fit: e[2] }); });
  return g;
}

function fmtPrice(n) { return n.toFixed(2).replace(".", ",") + " €"; }
